/* eslint-disable no-unused-vars */
import React from 'react';
import { FlexRow } from '@Components/common/Layouts';
import Flex from '@Components/common/Layouts/Flex';

type OptionsType = {
  value: any;
  label: string;
  name?: string;
};

type RadioButtonPropType = {
  options: OptionsType[];
  direction?: 'row' | 'column';
  onChangeData: (value: string) => void;
  value: string;
  errorMsg?: string;
  className?: string;
  required?: boolean;
};

const RadioButton: React.FC<RadioButtonPropType> = ({
  options,
  direction = 'column',
  onChangeData,
  value,
  errorMsg,
  className,
  required,
}) => (
  <div>
    <Flex
      className={`${
        direction === 'column'
          ? 'naxatw-flex-col naxatw-gap-y-2'
          : 'naxatw-flex-wrap naxatw-gap-x-16'
      }`}
    >
      {options.map(option => {
        return (
          <FlexRow
            key={option.value}
            className="naxatw-group naxatw-flex naxatw-gap-2"
          >
            <input
              type="radio"
              id={option.value}
              name={option?.name}
              value={option.value}
              className="naxatw-cursor-pointer naxatw-accent-primary-600"
              onChange={e => {
                onChangeData(e.target.value);
              }}
              checked={option.value === value}
            />
            <label
              htmlFor={option.value}
              className={`naxatw-label naxatw-text-body-sm naxatw-cursor-pointer naxatw-bg-white naxatw-font-normal !naxatw-text-matt-200 naxatw-duration-200 group-hover:!naxatw-text-gray-800  ${className}`}
            >
              <p>{option.label}</p>
            </label>
          </FlexRow>
        );
      })}
    </Flex>
  </div>
);

export default RadioButton;

// {
//   options.map(option => {
//     const stringValue = String(option.value); // Ensure the value is a string for comparison
//     return (
//       <FlexRow
//         key={stringValue}
//         className="naxatw-group naxatw-flex naxatw-gap-2"
//       >
//         <input
//           type="radio"
//           id={stringValue}
//           name={option?.name}
//           value={stringValue} // Ensure value is string
//           className="naxatw-cursor-pointer naxatw-accent-primary-600"
//           onChange={e => {
//             // Convert the string value to boolean and pass to onChangeData
//             const booleanValue = e.target.value === 'true'; // 'true' will become true, and 'false' will become false
//             onChangeData(booleanValue); // Pass boolean value to onChangeData
//           }}
//           checked={stringValue === value.toString()} // Compare as string
//         />
//         <label
//           htmlFor={stringValue}
//           className={`naxatw-label naxatw-text-body-sm naxatw-cursor-pointer naxatw-bg-white naxatw-font-normal !naxatw-text-matt-200 naxatw-duration-200 group-hover:!naxatw-text-gray-800  ${className}`}
//         >
//           <p>{option.label}</p>
//         </label>
//       </FlexRow>
//     );
//   });
// }
